/*
 * @Date: 2021-03-23 15:57:38
 * @LastEditors: 孙强强
 * @LastEditTime: 2021-09-16 17:35:06
 */
// /*
//  * @Date: 2020-06-01 17:39:28
//  * @LastEditors: guantingting
//  * @LastEditTime: 2021-03-05 16:48:40
//  */

import weChat from './wechat'
import { isAndroid, isIOS, isWeixin, isApp, isMiniprogram } from './untils'
// const wx = require('weixin-js-sdk')
import wx from 'weixin-js-sdk'
import {
  getlocation,
  openLocation,
  scanQRCode,
  closeWindow,
  hideMenuItems,
  showMenuItems,
  hideAllNonBaseMenuItem,
  showAllNonBaseMenuItem,
  setTitle,
  refreshOrShare,
  onAppReady,
  setPageInfo,
  setRightIcon,
  copyText,
  openMin,
  openWx,
  getHeaderHeight,
  getPhone,
  setShareInfo,
  share,
  getWxpayScore,
  setHeader,
  setBackBtnHide,
  checkPushSetting,
  openPushSetting
} from './sdk'

const miniProgram = wx && wx.miniProgram

// export const test = () => {
//   setBackBtnHide()
//   const r = getHeaderHeight()
//   alert(JSON.stringify(r))
// }

export {
  weChat,
  getlocation,
  openLocation,
  scanQRCode,
  closeWindow,
  hideMenuItems,
  showMenuItems,
  hideAllNonBaseMenuItem,
  showAllNonBaseMenuItem,
  setTitle,
  refreshOrShare,
  onAppReady,
  setPageInfo,
  setRightIcon,
  copyText,
  openMin,
  openWx,
  getHeaderHeight,
  getPhone,
  setShareInfo,
  share,
  getWxpayScore,
  wx,
  miniProgram,
  isAndroid,
  isIOS,
  isApp,
  isWeixin,
  isMiniprogram,
  setHeader,
  setBackBtnHide,
  checkPushSetting,
  openPushSetting
}
